'use client';

import Error from '@/app/error';

// App's -> Error Page
export default Error;
